import React, {Component} from 'react'
import './HintConfirmModal.css'

class HintConfirmModal extends Component {

  render() {
    const modalState = this.props.showModal ? 'visible' : 'hidden';
    const title = this.props.title || "Do you want to use your one hint?";
    const message = this.props.message || 'Using your hint will reveal all the valid remaining words. You only get one hint per game so use it wisely. Are you sure you want to use it now?';

    return (
      <div className="overlay HintConfirmModal" modal-state={modalState}>
        <div className="content">
          <div className="close-icon">
            <game-icon icon="close" onClick={this.props.closeModal}>
              <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                <path fill="var(--color-tone-1)" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
              </svg>
            </game-icon>
          </div>
          <h3 style={{textAlign: "center"}}>{title}</h3>
          <p className="hint-confirm-message">
            {message}
          </p>
          <div className="hint-confirm-actions">
            <button className="hint-confirm-button" onClick={this.props.onConfirm}>Yes</button>
            <button className="hint-confirm-button" onClick={this.props.closeModal}>No</button>
          </div>
        </div>
      </div>
    );
  }
}

export default HintConfirmModal;
